import { render, staticRenderFns } from "./StockReport.vue?vue&type=template&id=19d28f5c&scoped=true&"
import script from "./StockReport.vue?vue&type=script&lang=js&"
export * from "./StockReport.vue?vue&type=script&lang=js&"
import style0 from "./StockReport.vue?vue&type=style&index=0&id=19d28f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d28f5c",
  null
  
)

export default component.exports